<template>
  <div id="app">
    <!-- 认证后且不是登录页面时显示带侧边栏的布局 -->
    <div class="app-container" v-if="isAuthenticated && !isLoginPage">
      <!-- 侧边栏 -->
      <Sidebar />
      
      <!-- 主内容区 -->
      <main class="main-content">
        <router-view />
      </main>
    </div>
    
    <!-- 未认证或登录页面时直接显示内容 -->
    <router-view v-else />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Sidebar from './components/layout/Sidebar.vue';
import { useAuthStore } from './store/modules/auth';
import { pinia } from './store';

const route = useRoute();
const authStore = useAuthStore(pinia);

// 判断是否是登录页面
const isLoginPage = computed(() => {
  return route.path === '/login';
});

// 直接从authStore获取认证状态，这样登录后会自动响应更新
const isAuthenticated = computed(() => {
  return authStore.isAuthenticated;
});
</script>

<style scoped>
#app {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.app-container {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  margin-left: 200px; /* 与侧边栏宽度保持一致 */
  padding: 20px;
  min-height: 100vh;
  box-sizing: border-box;
}
</style>

<!-- 全局样式 - 确保Element Plus消息提示样式正确 -->
<style>
/* 全局CSS变量定义 */
:root {
  --el-message-success-bg-color: #f0f9eb;
  --el-message-success-border-color: #e1f3d8;
  --el-message-success-text-color: #67c23a;
  --el-message-error-bg-color: #fef0f0;
  --el-message-error-border-color: #fde2e2;
  --el-message-error-text-color: #f56c6c;
}

/* 最高优先级修复ElMessage success类型显示为红色的问题 */
body .el-message,
body .el-message-box {
  min-width: 300px;
}

/* 确保success类型消息显示为绿色 - 使用最高优先级选择器 */
body .el-message.el-message--success,
#app .el-message.el-message--success,
:deep(.el-message.el-message--success) {
  background-color: var(--el-message-success-bg-color) !important;
  border-color: var(--el-message-success-border-color) !important;
  color: var(--el-message-success-text-color) !important;
  background-image: none !important;
}

/* 确保success类型消息内容显示为绿色 */
body .el-message.el-message--success .el-message__content,
#app .el-message.el-message--success .el-message__content,
:deep(.el-message.el-message--success .el-message__content) {
  color: var(--el-message-success-text-color) !important;
}

/* 确保success类型图标显示正确 */
body .el-message.el-message--success .el-message__icon,
#app .el-message.el-message--success .el-message__icon,
:deep(.el-message.el-message--success .el-message__icon) {
  color: var(--el-message-success-text-color) !important;
}

/* 为success类型添加对勾图标 */
body .el-message.el-message--success .el-message__icon:before,
#app .el-message.el-message--success .el-message__icon:before,
:deep(.el-message.el-message--success .el-message__icon:before) {
  content: "\e666" !important;
  color: var(--el-message-success-text-color) !important;
}

/* 确保success类型关闭按钮颜色 */
body .el-message.el-message--success .el-message__closeBtn,
#app .el-message.el-message--success .el-message__closeBtn,
:deep(.el-message.el-message--success .el-message__closeBtn) {
  color: var(--el-message-success-text-color) !important;
}

/* 确保success类型消息的所有子元素都正确显示颜色 */
body .el-message.el-message--success *,
#app .el-message.el-message--success *,
:deep(.el-message.el-message--success *) {
  color: var(--el-message-success-text-color) !important;
}

/* 确保error类型消息样式正常 */
body .el-message.el-message--error,
#app .el-message.el-message--error,
:deep(.el-message.el-message--error) {
  background-color: var(--el-message-error-bg-color) !important;
  border-color: var(--el-message-error-border-color) !important;
  color: var(--el-message-error-text-color) !important;
}

/* 确保error类型消息内容显示正确 */
body .el-message.el-message--error .el-message__content,
#app .el-message.el-message--error .el-message__content,
:deep(.el-message.el-message--error .el-message__content) {
  color: var(--el-message-error-text-color) !important;
}

/* 确保error类型图标显示正确 */
body .el-message.el-message--error .el-message__icon,
#app .el-message.el-message--error .el-message__icon,
:deep(.el-message.el-message--error .el-message__icon) {
  color: var(--el-message-error-text-color) !important;
}
</style>